












































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import PatientFilter from '@/components/gap/filters/Patient.vue'
import ProviderFilter from '@/components/gap/filters/Provider.vue'
import MeasureFilter from '@/components/gap/filters/Measure.vue'
import ReferenceDateFilter from '@/components/gap/filters/ReferenceDate.vue'
import PriorityFilter from '@/components/gap/filters/Priority.vue'
import StatusFilter from '@/components/gap/filters/Status.vue'
import SubStatusFilter from '@/components/gap/filters/SubStatus.vue'
import CreatedFilter from '@/components/gap/filters/Created.vue'
import UpdatedFilter from '@/components/gap/filters/Updated.vue'
import PriorityPopover from '@/components/gap/edit/Priority.vue'
import StatusPopover from '@/components/gap/edit/Status.vue'
import SubStatusPopover from '@/components/gap/edit/SubStatus.vue'
import CallPopover from '@/components/gap/notif/Call.vue'
import SmsPopover from '@/components/gap/notif/SMS.vue'
import ConferencePopover from '@/components/gap/notif/Conference.vue'
import InputPopover from '@/components/InputPopover.vue'
import SelectPopover from '@/components/SelectPopover.vue'
import { getDate } from '@/services/timezone'

@Component({
  components: {
    PatientFilter,
    ProviderFilter,
    MeasureFilter,
    ReferenceDateFilter,
    PriorityFilter,
    StatusFilter,
    SubStatusFilter,
    CreatedFilter,
    UpdatedFilter,
    PriorityPopover,
    StatusPopover,
    SubStatusPopover,
    CallPopover,
    SmsPopover,
    ConferencePopover,
    InputPopover,
    SelectPopover
  },
  computed: {
    ...mapState('gaps', ['filter', 'users']),
    ...mapGetters('gaps', [
      'idFilterOn',
      'patientFilterOn',
      'providerFilterOn',
      'measureFilterOn',
      'refdateFilterOn',
      'priorityFilterOn',
      'statusFilterOn',
      'subStatusFilterOn',
      'ownerUserFilterOn',
      'createdFilterOn',
      'updatedFilterOn'
    ])
  }
})
export default class GapList extends Vue {
  @Prop(Array) readonly items!: Array<any>
  @Prop(Array) readonly providers!: Array<any>
  @Prop(String) readonly orderBy!: String
  @Watch('items')
  onItemsChanged() {
    this.showPatientFilter = false
    this.showProviderFilter = false
    this.showMeasureFilter = false
    this.showRefDateFilter = false
    this.showPriorityFilter = false
    this.showStatusFilter = false
    this.showSubStatusFilter = false
    this.showCreatedFilter = false
    this.showUpdatedFilter = false
    this.priorityPopover.show = false
    this.statusPopover.show = false
    this.subStatusPopover.show = false
    this.callPopover.show = false
    this.smsPopover.show = false
    this.conferencePopover.show = false
    this.lastShownFilter = ''
    this.lastShownEdit = null
  }
  getDate = getDate
  showPatientFilter = false
  showProviderFilter = false
  showMeasureFilter = false
  showRefDateFilter = false
  showPriorityFilter = false
  showStatusFilter = false
  showSubStatusFilter = false
  showCreatedFilter = false
  showUpdatedFilter = false
  lastShownFilter!: string
  lastShownEdit!: any
  priorityPopover = {
    entityRequired: false,
    gap: null,
    show: false
  }
  statusPopover = {
    entityRequired: false,
    gap: null,
    show: false
  }
  subStatusPopover = {
    entityRequired: false,
    gap: null,
    show: false
  }
  smsPopover = {
    entityRequired: true,
    gap: null,
    show: false
  }
  callPopover = {
    entityRequired: true,
    gap: null,
    show: false
  }
  conferencePopover = {
    entityRequired: true,
    gap: null,
    show: false
  }
  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter)
    }
    let show = false
    switch (filter) {
      case 'PATIENT':
        show = !this.showPatientFilter
        this.showPatientFilter = show
        break
      case 'PROVIDER':
        show = !this.showProviderFilter
        this.showProviderFilter = show
        break
      case 'MEASURE':
        show = !this.showMeasureFilter
        this.showMeasureFilter = show
        break
      case 'REFDATE':
        show = !this.showRefDateFilter
        this.showRefDateFilter = show
        break
      case 'PRIORITY':
        show = !this.showPriorityFilter
        this.showPriorityFilter = show
        break
      case 'STATUS':
        show = !this.showStatusFilter
        this.showStatusFilter = show
        break
      case 'SUB-STATUS':
        show = !this.showSubStatusFilter
        this.showSubStatusFilter = show
        break
      case 'CREATED':
        show = !this.showCreatedFilter
        this.showCreatedFilter = show
        break
      case 'UPDATED':
        show = !this.showUpdatedFilter
        this.showUpdatedFilter = show
        break
    }
    this.lastShownFilter = show ? filter : ''
  }
  showHideEdit(gap, popover) {
    if (popover.entityRequired && !this.entitySelected()) return
    if (this.lastShownEdit && this.lastShownEdit !== popover) {
      this.lastShownEdit.gap = null
      this.lastShownEdit.show = false
    }
    const show = !popover.show
    popover.gap = show ? gap : null
    popover.show = show
    this.lastShownEdit = show ? popover : null
  }
  notifButtonColor(count) {
    if (count) {
      if (count <= 3) {
        return 'border-success text-success'
      } else if (count <= 6) {
        return 'border-warning text-warning'
      } else {
        return 'border-danger text-danger'
      }
    } else {
      return 'wm-br-2 wm-fc-2'
    }
  }
  entitySelected(): boolean {
    if (this.$store.state.auth.entityId == 0) {
      this.$modal.show('dialog', {
        title: 'PatientCare',
        text: "Please select an <span class='wm-fw-500'>area or division</span>."
      })
      return false
    }
    return true
  }
  setIdFilter(value: string) {
    this.$store.commit('gaps/SET_ID_FILTER', value)
  }
  setTransportationFilter(value: string) {
    this.$store.commit('gaps/SET_TRANSPORTATION_FILTER', value)
  }
  setOwnerUserFilter(value: number[]) {
    this.$store.commit('gaps/SET_OWNER_USER_FILTER', value)
  }

async setProvider(provider: any, gap: any) {
  try {
    await this.$store.dispatch("gaps/saveProvider", {
      gapId: gap.id,
      providerId: provider.id
    });
    gap.providerId = provider.id;
    gap.providerName = provider.name;

     this.$bvToast.toast(`Gap #${gap.id} has been updated.`, {
      title: "WaitingMed",
      toaster: "b-toaster-top-right",
      autoHideDelay: 3000,
      solid: true,
    });

  } catch (error) {
    console.log(error);
  } finally {
    console.log("GAP UPDATED");
  }
}
}
